// tools to 

export function isEmail(email)
{
	const expression = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+.)+[^<>()[\].,;:\s@"]{2,})$/i;
	return expression.test(String(email).toLowerCase());
}

